// Inline stroke icons (24px, stroke-width 2) — no icon-font dependency.
interface IconProps { size?: number; className?: string }
const base = (size = 24, className?: string) => ({
  width: size, height: size, viewBox: '0 0 24 24', fill: 'none',
  stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const, className,
})

export const IconGetReady = ({ size, className }: IconProps) => (
  <svg {...base(size, className)}><path d="M9 11l3 3L22 4" /><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" /></svg>
)
export const IconOrders = ({ size, className }: IconProps) => (
  <svg {...base(size, className)}><path d="M6 2h9l5 5v13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z" /><path d="M14 2v5h5M9 12h6M9 16h6M9 8h2" /></svg>
)
export const IconTickets = ({ size, className }: IconProps) => (
  <svg {...base(size, className)}><path d="M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2 2 2 0 0 0 0 6 2 2 0 0 1-2 2H5a2 2 0 0 1-2-2 2 2 0 0 0 0-6z" /><path d="M13 7v10" strokeDasharray="2 2" /></svg>
)
export const IconProfile = ({ size, className }: IconProps) => (
  <svg {...base(size, className)}><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></svg>
)
// Mobile topbar account control — line-art person icon, NEVER initials
// (canon §3.2 / §11.2; DC source path).
export const IconPerson = ({ size, className }: IconProps) => (
  <svg {...base(size, className)}><circle cx="12" cy="8" r="3.4" /><path d="M5.5 20c0-3.6 2.9-6 6.5-6s6.5 2.4 6.5 6" /></svg>
)
export const IconHelp = ({ size, className }: IconProps) => (
  <svg {...base(size, className)}><circle cx="12" cy="12" r="9" /><path d="M9.3 9a2.7 2.7 0 0 1 5.2 1c0 1.8-2.7 2.5-2.7 2.5" /><path d="M12 17h.01" /></svg>
)
export const IconBell = ({ size, className }: IconProps) => (
  <svg {...base(size, className)}><path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.7 21a2 2 0 0 1-3.4 0" /></svg>
)
export const IconChevron = ({ size, className }: IconProps) => (
  <svg {...base(size, className)}><path d="M9 18l6-6-6-6" /></svg>
)
export const IconBack = ({ size, className }: IconProps) => (
  <svg {...base(size, className)}><path d="M15 18l-6-6 6-6" /></svg>
)
export const IconCheck = ({ size, className }: IconProps) => (
  <svg {...base(size, className)}><path d="M20 6L9 17l-5-5" /></svg>
)
// Profile-section settings-row icons — line-art replacements for the DC's
// emoji glyphs (🔑 🛡️ 🔔 ↩︎), canon §9 + open decision §12.8 (product icon
// set, consistent with the nav icons; exact glyph choice TBD).
export const IconKey = ({ size, className }: IconProps) => (
  <svg {...base(size, className)}><circle cx="7.5" cy="16.5" r="4.5" /><path d="M10.7 13.3L21 3" /><path d="M15 5l4 4" /></svg>
)
export const IconShield = ({ size, className }: IconProps) => (
  <svg {...base(size, className)}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>
)
export const IconSignOut = ({ size, className }: IconProps) => (
  <svg {...base(size, className)}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="M16 17l5-5-5-5" /><path d="M21 12H9" /></svg>
)
